import React from 'react';
import { useAITTheme } from '../ui/theme';

const TripsCarIcon: React.FC = () => {
  const { theme } = useAITTheme();
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 512 512">
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M480.56,183.19l-35.02-105.09c-5.08-15.3-14.85-28.6-27.93-38.03-13.07-9.43-28.79-14.49-44.9-14.48h-233.42c-16.12-.01-31.83,5.05-44.91,14.48s-22.85,22.73-27.93,38.03l-35.02,105.09c-9.3,3.9-17.25,10.47-22.84,18.86C3.01,210.45.02,220.31,0,230.4v128c0,19.28,10.83,35.89,26.6,44.62-.33,1.69-1,3.23-1,4.99v52.79c0,6.79,2.7,13.3,7.5,18.1,4.8,4.8,11.31,7.5,18.1,7.5h25.6c6.79,0,13.3-2.7,18.1-7.5,4.8-4.8,7.5-11.31,7.5-18.1v-51.2h307.2v51.2c0,6.79,2.7,13.3,7.5,18.1s11.31,7.5,18.1,7.5h25.6c6.79,0,13.3-2.7,18.1-7.5s7.5-11.31,7.5-18.1v-52.79c0-1.77-.67-3.33-1-4.99,8.02-4.38,14.73-10.82,19.4-18.67,4.68-7.85,7.17-16.81,7.2-25.95v-128c0-21.22-13-39.45-31.44-47.21h0ZM51.2,358.4v-128h409.6l.05,128H51.2ZM139.29,76.8h233.4c11.03,0,20.81,7.01,24.29,17.51l28.31,84.89H86.71l28.29-84.89c1.7-5.1,4.96-9.54,9.32-12.68s9.6-4.83,14.97-4.83h0Z"
      />
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M396.8,332.8c21.21,0,38.4-17.19,38.4-38.4s-17.19-38.4-38.4-38.4-38.4,17.19-38.4,38.4,17.19,38.4,38.4,38.4Z"
      />
      <path
        fill={theme.tokens.colors.brand.primary}
        fillRule="evenodd"
        d="M115.2,332.8c21.21,0,38.4-17.19,38.4-38.4s-17.19-38.4-38.4-38.4-38.4,17.19-38.4,38.4,17.19,38.4,38.4,38.4Z"
      />
    </svg>
  );
};

export default TripsCarIcon;
